module.exports = __webpack_public_path__ + "img/灵活极速的自助取数@2x.8113acc9.png";